/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum StatisticsSendStatus {
  ReceivedByPhone = 1,
  NotReceiveByPhone = 2,
  SentToItc = 3,
  NotReceivedByItc = 4,
  BlackList = 5,
  InvalidPrivateNumber = 6
}
